import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/loader/allocation/styles.scss';export default {
  "main": "_main_1k15x_1",
  "resource": "_resource_1k15x_7",
  "iconBox": "_iconBox_1k15x_18",
  "icon": "_icon_1k15x_18",
  "openedIcon": "_openedIcon_1k15x_34",
  "row": "_row_1k15x_38",
  "avatar": "_avatar_1k15x_47",
  "col": "_col_1k15x_55",
  "name": "_name_1k15x_65",
  "profession": "_profession_1k15x_70",
  "recordList": "_recordList_1k15x_75"
};